import { CommentsField } from '@src/permitField/CommentsFields';
import { companyAddressFields } from '@src/permitField/CompanyAddressFields';
import { companyInformationFields } from '@src/permitField/CompanyInformationSectionFields';
import {
  orderInformationFields,
  permitDeliveryAndNotificationsFields,
} from '@src/permitField/PermitDeliveryAndNotificationsFields';

export const PERMIT_TYPE_DEFAULT_FIELDS = [
  CommentsField.fieldName,
  ...Object.keys(companyInformationFields),
  ...Object.keys(companyAddressFields),
  ...Object.keys(permitDeliveryAndNotificationsFields),
  ...Object.keys(orderInformationFields),
];
